import {AfterContentChecked, ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, OnDestroy, OnInit} from '@angular/core';
import {PostDataService} from '../../services/post-data.service';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material';
import {FormControl, FormGroup, Validators} from '@angular/forms';

@Component({
	selector: 'app-user-input',
	templateUrl: './user-input.component.html',
	styleUrls: ['./user-input.component.css'],
	changeDetection: ChangeDetectionStrategy.OnPush

})
export class UserInputComponent implements OnInit, AfterContentChecked, OnDestroy {
	public detailsActive: boolean;
	public formValid: boolean;
	public languageActive: boolean;
	public participationActive: boolean;
	public editMode: boolean;


	constructor(public postDataService: PostDataService, public dialogRef: MatDialogRef<UserInputComponent>, @Inject(MAT_DIALOG_DATA) public data, private cdr: ChangeDetectorRef) {
	}

	public essayActive: boolean;

	category = {
		'Essay Writing': ['7th 8th & 9th Regional', '7th 8th & 9th National', '10th 11th & 12th Regional', '10th 11th & 12th National'],
		'Project & Working Model': ['7th 8th & 9th National', '10th 11th & 12th National']
	};
	categories = Object.keys(this.category);
	languages = ['Gujarati', 'Bengali', 'Marathi', 'Tamil', 'Telugu', 'Hindi', 'Kannada', 'Odiya', 'Urdu', 'Punjabi', 'Malayalam'];
	isRegional = false;
	essaySubCategories = [];
	projectSubCategories = [];
	standard = [];

	participation: boolean;
	details: any;

	UserDetails = new FormGroup({
		UserFirstName: new FormControl('', [Validators.required, this.noWhitespaceValidator]),
		UserLastName: new FormControl('', [Validators.required, this.noWhitespaceValidator]),
		UserEmail: new FormControl('', [Validators.email]),
		UserCategory: new FormControl('', [Validators.required]),
		UserStandard: new FormControl('', [Validators.required]),
		UserSubCategory: new FormControl('', [Validators.required]),
		HasParticipated: new FormControl(''),
		UserLanguage: new FormControl(''),
		UserParticipationDetails: new FormControl('')
	});


	ngOnInit() {
		this.participation = this.postDataService.student.hasParticipated;
		this.details = this.postDataService.student.details;
		this.onChange();
		this.postDataService.EditModeSubject.subscribe((editMode) => {
			if (editMode) {
				this.editMode = true;
				this.UserDetails.setValue({
					UserFirstName: this.postDataService.student.firstName,
					UserLastName: this.postDataService.student.lastName,
					UserEmail: this.postDataService.student.email,
					UserCategory: this.postDataService.student.entryCategory,
					UserStandard: this.postDataService.student.standard,
					UserSubCategory: this.postDataService.student.entrySubCategory,
					HasParticipated: this.postDataService.student.hasParticipated,
					UserLanguage: this.postDataService.student.language,
					UserParticipationDetails: this.postDataService.student.details
				});
			}
		});
		this.dialogRef.beforeClosed().subscribe((data) => {
			console.log(data);
			this.postDataService.student = {...this.postDataService.resetStudent};
			this.postDataService.EditModeSubject.next(false);
		});
	}

	onChangeHandler(event: string) {
		switch (event) {
			case 'Essay Writing':
				this.essayActive = true;
				this.essaySubCategories = this.category[event];
				this.projectSubCategories = [];
				this.standard = [];
				this.postDataService.student.entryCategory = event;
				this.UserDetails.controls.UserCategory.setValue(event);
				if (!this.editMode) {
					this.postDataService.student.entrySubCategory = null;
					this.UserDetails.controls.UserSubCategory.setValue('');
					this.postDataService.student.standard = null;
					this.UserDetails.controls.UserStandard.setValue('');
				}
				break;
			case 'Project & Working Model':
				this.essayActive = false;
				this.participation = false;
				this.essaySubCategories = [];
				this.projectSubCategories = this.category[event];
				this.standard = [];
				this.postDataService.student.entryCategory = event;
				this.UserDetails.controls.UserCategory.setValue(event);
				if (!this.editMode) {
					this.postDataService.student.entrySubCategory = null;
					this.UserDetails.controls.UserSubCategory.setValue('');
					this.postDataService.student.standard = null;
					this.UserDetails.controls.UserStandard.setValue('');
				}

				break;
			case '7th 8th & 9th Regional':
			case '7th 8th & 9th National':
				this.standard = [7, 8, 9];
				this.isRegional = event.includes('Regional');
				this.postDataService.student.entrySubCategory = event;
				this.UserDetails.controls.UserSubCategory.setValue(event);
				if (!this.editMode) {
					this.postDataService.student.standard = null;
					this.UserDetails.controls.UserStandard.setValue('');
				}


				break;
			case '10th 11th & 12th Regional':
			case '10th 11th & 12th National':
				this.standard = [10, 11, 12];
				this.isRegional = event.includes('Regional');
				this.postDataService.student.entrySubCategory = event;
				this.UserDetails.controls.UserSubCategory.setValue(event);
				if (!this.editMode) {
					this.postDataService.student.standard = null;
					this.UserDetails.controls.UserStandard.setValue('');
				}
				break;
		}
	}


	onChangeFirstName(event: string) {
		this.postDataService.student.firstName = event;
		this.UserDetails.controls.UserFirstName.setValue(event);
	}

	onChangeLastName(event: string) {
		this.postDataService.student.lastName = event;
		this.UserDetails.controls.UserLastName.setValue(event);
	}

	onChangeEmail(event: string) {
		this.postDataService.student.email = event;
		this.UserDetails.controls.UserEmail.setValue(event);
	}

	onChangeStandard(event: string) {
		this.postDataService.student.standard = +event;
		this.UserDetails.controls.UserStandard.setValue(event);
	}

	onChangeLanguage(event: string) {
		this.postDataService.student.language = event;
		this.UserDetails.controls.UserLanguage.setValue(event);
	}

	save() {
		if (!this.editMode) {
			this.postDataService.student.instituteName = this.postDataService.instituteData.instituteName;
			this.postDataService.student.pincode = this.postDataService.instituteData.institutePin;
			this.postDataService.student.instituteState = this.postDataService.instituteData.instituteState;
			this.postDataService.student.details = this.details;
			if (!this.postDataService.student.email) {
				this.postDataService.student.email = this.postDataService.instituteData.instituteEmail;
			}
			this.postDataService.instituteData.students.push(this.postDataService.student);
			this.UserDetails.reset();
			// this.postDataService.student = this.postDataService.resetStudent;
		} else {
			if (!this.postDataService.student.email) {
				this.postDataService.student.email = this.postDataService.instituteData.instituteEmail;
			}
			this.postDataService.instituteData.students[this.postDataService.editStudentDetails] = this.postDataService.student;
			this.postDataService.EditModeSubject.next(false);
			this.UserDetails.reset();
			this.postDataService.editStudentDetails = null;

		}
		this.dialogRef.close();
	}

	onClickParticipation() {
		this.participation = !this.participation;
		this.postDataService.student.hasParticipated = this.participation;
		this.detailsActive = this.participation;
		this.participation ? this.detailsActive = false : this.detailsActive = true;
		this.UserDetails.controls.HasParticipated.setValue(this.participation);
	}

	ngAfterContentChecked(): void {
		this.cdr.detectChanges();
	}

	onChange() {
		this.UserDetails.valueChanges.subscribe((value) => {
				if (this.essayActive) {
					if (this.isRegional) {
						this.languageActive = this.postDataService.student.language && this.postDataService.student.language.length > 0;
					} else {
						this.languageActive = true;
					}
					if (this.participation) {
						this.participationActive = this.details && this.details.length > 0;
					} else {
						this.participationActive = true;
					}
					this.formValid = this.languageActive && this.participationActive;
				} else {
					this.formValid = true;
				}
			}
		);
	}

	onChangeDetails(value: any) {
		this.UserDetails.controls.UserParticipationDetails.setValue(value);
	}

	ngOnDestroy() {
		this.postDataService.student = {...this.postDataService.resetStudent};
		this.UserDetails.reset();
	}


	public noWhitespaceValidator(control: FormControl) {
		const isWhitespace = (control.value || '').trim().length === 0;
		const isValid = !isWhitespace;
		return isValid ? null : {'whitespace': true};
	}
}
